import { render, staticRenderFns } from "./CanaryMarker.vue?vue&type=template&id=2664d2de&scoped=true"
import script from "./CanaryMarker.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanaryMarker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CanaryMarker.vue?vue&type=style&index=0&id=2664d2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664d2de",
  null
  
)

export default component.exports